import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const isResizeObserverNoise = (value = '') =>
  String(value).includes('ResizeObserver loop completed with undelivered notifications') ||
  String(value).includes('ResizeObserver loop limit exceeded');

if (process.env.NODE_ENV === 'development') {
  const suppressRuntimeNoise = (event) => {
    const msg = event?.message || event?.error?.message || '';
    if (!isResizeObserverNoise(msg)) return;
    event.preventDefault?.();
    event.stopPropagation?.();
    event.stopImmediatePropagation?.();
  };
  window.addEventListener('error', suppressRuntimeNoise, true);

  window.addEventListener('unhandledrejection', (event) => {
    const reason = event?.reason?.message || event?.reason || '';
    if (!isResizeObserverNoise(reason)) return;
    event.preventDefault?.();
    event.stopPropagation?.();
    event.stopImmediatePropagation?.();
  }, true);

  // Final fallback: remove dev overlay containers if they still appear.
  const removeDevOverlays = () => {
    const selectors = [
      '#react-error-overlay',
      '#webpack-dev-server-client-overlay',
      'iframe[id*="overlay"]',
      'iframe[class*="overlay"]',
      'div[id*="webpack-dev-server-client-overlay"]',
    ];
    selectors.forEach((sel) => {
      document.querySelectorAll(sel).forEach((el) => { el.remove(); });
    });
  };
  removeDevOverlays();
  const observer = new MutationObserver(removeDevOverlays);
  observer.observe(document.documentElement, { childList: true, subtree: true });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><App /></React.StrictMode>);
